import keys from 'lodash/keys';

// obtain the url-param for deep-linking
const deeplink = new URLSearchParams(window.location.search).get('deeplink') || '';

const FINANCIAL_HARDSHIP = 'Financial hardship application';
const lodgement = deeplink.toLowerCase() === FINANCIAL_HARDSHIP.toLowerCase() ? FINANCIAL_HARDSHIP : undefined;

export const initialValuesLandingFormFields = {
  lodgement,
};

export const initialHardshipPersonalFormFields = {
  title: '',
  firstName: '',
  lastName: '',
  organisation: '',
  dependents: [],
  isLangInterpreter: '',
  language: '',
  otherLanguage: null,
};

export const initialValuesConsentFormFields = {
  policyOrClaim: '',
  policyNumber: '',
  claimNumber: '',
  relationship: '',
  firstName: '',
  lastName: '',
  organisation: '',
  dependentData: [],
  personalDetails: false,
  contactDetails: false,
  emailAddress: '',
  phoneNumber: '',
  contactType: null,
  contactPreferedMethod: null,

  physicalAddress: '',
  phyStreetAddress: '',
  phySuburb: '',
  phyCountry: '',
  phyState: '',
  phyPostcode: '',
  isPhysAddressValid: false,
  isManualPhysAddress: false,
  physicalAddressObject: null,
  isManualPhysAddressValid: false,

  postalAddress: '',
  posStreetAddress: '',
  posSuburb: '',
  posCountry: '',
  posState: '',
  posPostcode: '',
  isPosAddressValid: false,
  isManualPosAddress: false,
  postalAddressObject: null,
};

export const initialValuesInsuredDetailsFormFields = {
  indOrBus: null,
  // Your Details
  title: null,
  firstname: '',
  lastname: '',
  dob: null,
  gender: null,

  cEmailAddress: '',
  addressType: null,

  mPhoneNumber: '',
  hPhoneNumber: '',
  oPhoneNumber: '',
  iContactPreferedMethod: '',

  isLangInterpreter: '',
  vulnerableCustomer: '',
  language: '',
  otherLanguage: '',
  businessName: '',
  isSmallBusiness: undefined,
};

export const initialFinRepresentativeFields = {
  nominatedRepType: '',
  repFirstName: '',
  repLastName: '',
  repContactMethod: '',
  repEmailAddress: '',
  repPostalAddress: '',
  repPostalAddressObject: null,
  repPosStreetAddress: '',
  repPosSuburb: '',
  repPosCountry: '',
  repPosState: '',
  repPosPostcode: '',
  isRepPosAddressValid: false,
  isManualRepPosAddress: false,
  repMPhoneNumber: '',
  repHPhoneNumber: '',
  repOPhoneNumber: '',
};

export const initialValuesComplaintDetailsFormFields = {
  complaintDate: null,
  productType: '',
  compDescription: '',
  compType: '',
  compArea: '',
  compCategory: [],
  sensitiveCase: '',
  resolved: '',
  desiredOutcome: '',
  resolvedDate: null,
  outcomeType: '',
  outcomeDesc: '',
  amountInDispute: '',
  amountCompResolved: '',
  files: [],
};

export const initialHardshipFields = {
  reason: '',
  assistance: null,
  description: '',
};

export const initialEmploymentFormFields = {
  employmentStatus: '',
  employmentData: [],
};

export const initialIncomeFormFields = {
  incomeStatus: '',
  incomeData: [],
};

export const initialExpenseFormFieldsNumber = {
  rentMortgage: undefined,
  childSupport: undefined,
  otherLoan: undefined,
  motorVehicle: undefined,
  creditCard: undefined,
  livingCosts: undefined,
  utilities: undefined,
  schoolFees: undefined,
  hospitalMedicalCosts: undefined,
  insurance: undefined,
  otherExpense: undefined,
};
export const initialExpenseFormFields = {
  ...initialExpenseFormFieldsNumber,
  declaration: false,
  files: [],
};

export const expenseFormFieldsNumberKeys = keys(initialExpenseFormFieldsNumber);

export const initialState = {
  ...initialHardshipPersonalFormFields,
  ...initialHardshipFields,
  ...initialIncomeFormFields,
  ...initialExpenseFormFields,
  ...initialValuesLandingFormFields,
  ...initialValuesConsentFormFields,
  ...initialFinRepresentativeFields,
  ...initialValuesInsuredDetailsFormFields,
  ...initialValuesComplaintDetailsFormFields,
};
